var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c("el-card", { staticClass: "box-card bg-purple" }, [
        _c(
          "div",
          {
            staticClass: "clearfix",
            attrs: { slot: "header" },
            slot: "header"
          },
          [
            _vm._v("Στατιστικά"),
            _c(
              "el-button",
              {
                staticStyle: { float: "right", padding: "3px 0" },
                attrs: { type: "text" },
                on: { click: _vm.toggleStats }
              },
              [_vm._v("Κλείσιμο")]
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "text item" },
          [
            _c("el-switch", {
              attrs: {
                "active-text": " Χρηστών-Ρόλων",
                "inactive-text": " Αναγνωρίσεων-Κατάθεσης Αιτήσεων"
              },
              model: {
                value: _vm.searchTypeUsers,
                callback: function($$v) {
                  _vm.searchTypeUsers = $$v
                },
                expression: "searchTypeUsers"
              }
            }),
            _c("hr"),
            _c("el-date-picker", {
              attrs: {
                type: "date",
                placeholder: "Υποβληθείσες από...",
                format: "dd-MM-yyyy",
                "value-format": "dd-MM-yyyy"
              },
              model: {
                value: _vm.dateFrom,
                callback: function($$v) {
                  _vm.dateFrom = $$v
                },
                expression: "dateFrom"
              }
            }),
            _c("el-date-picker", {
              attrs: {
                type: "date",
                placeholder: "...Υποβληθείσες μέχρι",
                format: "dd-MM-yyyy",
                "value-format": "dd-MM-yyyy"
              },
              model: {
                value: _vm.dateTo,
                callback: function($$v) {
                  _vm.dateTo = $$v
                },
                expression: "dateTo"
              }
            }),
            _c(
              "div",
              [
                _c(
                  "el-select",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.searchTypeUsers,
                        expression: "searchTypeUsers"
                      },
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.gettingRoles,
                        expression: "gettingRoles"
                      }
                    ],
                    staticClass: "big",
                    attrs: {
                      placeholder: "Ρόλος",
                      filterable: "filterable",
                      clearable: "clearable"
                    },
                    model: {
                      value: _vm.role,
                      callback: function($$v) {
                        _vm.role = $$v
                      },
                      expression: "role"
                    }
                  },
                  _vm._l(_vm.rolesAvailable, function(role) {
                    return _c("el-option", {
                      key: role.id,
                      attrs: { label: role.gr_name, value: role.name }
                    })
                  })
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.searchTypeUsers,
                        expression: "searchTypeUsers"
                      }
                    ],
                    staticClass: "searchButton",
                    attrs: { type: "primary" },
                    on: { click: _vm.statsPerRole }
                  },
                  [_vm._v(" Αναζήτηση Ρόλου")]
                )
              ],
              1
            ),
            _c(
              "el-select",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.searchTypeUsers,
                    expression: "searchTypeUsers"
                  },
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.gettingUsers,
                    expression: "gettingUsers"
                  }
                ],
                staticClass: "big",
                attrs: {
                  placeholder: "Χρήστης",
                  filterable: "filterable",
                  clearable: "clearable"
                },
                on: { focus: _vm.getUsers },
                model: {
                  value: _vm.selectedUser,
                  callback: function($$v) {
                    _vm.selectedUser = $$v
                  },
                  expression: "selectedUser"
                }
              },
              _vm._l(_vm.users, function(user) {
                return _c("el-option", {
                  key: user.id,
                  attrs: { label: user.name, value: user.id }
                })
              })
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.searchTypeUsers,
                    expression: "searchTypeUsers"
                  }
                ],
                staticClass: "searchButton",
                attrs: { type: "primary" },
                on: { click: _vm.statsPerUser }
              },
              [_vm._v(" Αναζήτηση Χρήστη")]
            ),
            _c(
              "el-select",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.searchTypeUsers,
                    expression: "!searchTypeUsers"
                  },
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.gettingAcademicAreas,
                    expression: "gettingAcademicAreas"
                  }
                ],
                staticClass: "big",
                attrs: {
                  placeholder: "Ακαδημαϊκή πειριοχή",
                  filterable: "filterable",
                  clearable: "clearable"
                },
                on: { focus: _vm.getAcademicAreas },
                model: {
                  value: _vm.selectedAcademicArea,
                  callback: function($$v) {
                    _vm.selectedAcademicArea = $$v
                  },
                  expression: "selectedAcademicArea"
                }
              },
              _vm._l(_vm.academicAreas, function(area) {
                return _c("el-option", {
                  key: area.id,
                  attrs: { label: area.name, value: area.id }
                })
              })
            ),
            _c(
              "el-select",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.searchTypeUsers,
                    expression: "!searchTypeUsers"
                  },
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.gettingCountries,
                    expression: "gettingCountries"
                  }
                ],
                staticClass: "big",
                attrs: {
                  placeholder: "Χώρα",
                  filterable: "filterable",
                  clearable: "clearable"
                },
                on: { focus: _vm.getCountries },
                model: {
                  value: _vm.selectedCountry,
                  callback: function($$v) {
                    _vm.selectedCountry = $$v
                  },
                  expression: "selectedCountry"
                }
              },
              _vm._l(_vm.countries, function(country) {
                return _c("el-option", {
                  key: country.id,
                  attrs: { label: country.name, value: country.id }
                })
              })
            ),
            _c(
              "el-select",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.searchTypeUsers,
                    expression: "!searchTypeUsers"
                  },
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.gettingAppTypes,
                    expression: "gettingAppTypes"
                  }
                ],
                staticClass: "big",
                attrs: {
                  placeholder: "Τύπος Αίτησης",
                  filterable: "filterable",
                  clearable: "clearable"
                },
                on: { focus: _vm.getAppTypes },
                model: {
                  value: _vm.selectedAppType,
                  callback: function($$v) {
                    _vm.selectedAppType = $$v
                  },
                  expression: "selectedAppType"
                }
              },
              _vm._l(_vm.appTypes, function(appType) {
                return _c("el-option", {
                  key: appType.id,
                  attrs: { label: appType.name, value: appType.id }
                })
              })
            ),
            _c(
              "el-select",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.searchTypeUsers,
                    expression: "!searchTypeUsers"
                  }
                ],
                staticClass: "big",
                attrs: {
                  placeholder: "Ταξινόμηση με",
                  filterable: "filterable",
                  clearable: "clearable"
                },
                model: {
                  value: _vm.selectedSortBy,
                  callback: function($$v) {
                    _vm.selectedSortBy = $$v
                  },
                  expression: "selectedSortBy"
                }
              },
              _vm._l(_vm.sortChoises, function(sortBy) {
                return _c("el-option", {
                  key: sortBy,
                  attrs: { label: sortBy, value: sortBy }
                })
              })
            ),
            _c(
              "p",
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.searchTypeUsers,
                        expression: "!searchTypeUsers"
                      }
                    ],
                    staticClass: "searchButton",
                    attrs: { type: "primary" },
                    on: { click: _vm.statsRecognSubmit }
                  },
                  [_vm._v("Αναζήτηση")]
                )
              ],
              1
            ),
            _c("p", [_c("span", { domProps: { innerHTML: _vm._s(_vm.json) } })])
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fcbb3fd8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fcbb3fd8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Statistics.vue
// module id = null
// module chunks = 